import Cooking from '@/models/Cooking'
import User, { hasRole, Role } from '@/models/User'

export default class CookingPolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, cooking: Cooking) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === cooking.entry.catalog.company.id
			case Role.AUDITOR:
				return cooking.entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, cooking: Cooking) {
		return hasRole(user, Role.USER) && user.company?.id === cooking.entry.catalog.company.id
	}

	restore(user: User, cooking: Cooking) {
		return hasRole(user, Role.USER) && user.company?.id === cooking.entry.catalog.company.id
	}

	delete(user: User, cooking: Cooking) {
		return hasRole(user, Role.USER) && user.company?.id === cooking.entry.catalog.company.id
	}

	forceDelete(_user: User, _cooking: Cooking) {
		return false
	}
}
